import "regenerator-runtime/runtime"
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

// import * as React from "react"
// import { ThemeProvider } from "@mui/material/styles"
// import { CssBaseline } from "@mui/material"
// import theme from "./src/theme"
// import "./src/styles/global.css"
// import { Provider } from "react-redux"
// import store from "./src/state/store"
// export const wrapRootElement = ({ element }) => (
//   <Provider store={store}>
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       {element}
//     </ThemeProvider>
//   </Provider>
// )

// gatsby-browser.js
import React from "react"
import GlobalLayout from "./src/components/GlobalLayout"
import { ThemeProvider, CssBaseline } from "@mui/material"
import theme from "./src/theme"
import { Provider } from "react-redux"
import store from "./src/state/store"
import "./src/styles/global.css"
import { WebSocketProvider } from "./src/websocket/webSocket"
import { processPendingUploads } from "./src/utilities/processPendingUploads"
import { audioUpload } from "./src/state/patient/patientActions"
import { TwilioProvider } from "./src/contexts/TwilioContext"
import { initSessionRefresh } from "./src/utilities/axiosRequest"

let processDebounceTimer = null

const debouncedProcessPendingUploads = () => {
    if (processDebounceTimer) {
        clearTimeout(processDebounceTimer)
    }

    processDebounceTimer = setTimeout(() => {
        processPendingUploads(
            (formData, success, failure) => {
                store.dispatch(audioUpload(formData, success, failure))
            },
            fileId => {
                // store.dispatch(setAudioFileId(fileId))
            }
        )
    }, 1000) // Wait 1 second before processing
}

export const onClientEntry = () => {
    initSessionRefresh()
    if (typeof window !== "undefined") {
        console.log("Gatsby app loaded, checking for pending uploads...")

        // Wait a bit for the app to be fully initialized
        setTimeout(() => {
            debouncedProcessPendingUploads(
                (formData, success, failure) => {
                    store.dispatch(audioUpload(formData, success, failure))
                },
                fileId => {
                    // store.dispatch(setAudioFileId(fileId))
                }
            )
        }, 1000)
    }
}

if (typeof window !== "undefined") {
    window.addEventListener("online", () => {
        console.log("Network restored, processing pending uploads...")
        debouncedProcessPendingUploads(
            (formData, success, failure) => {
                store.dispatch(audioUpload(formData, success, failure))
            },
            fileId => {
                // store.dispatch(setAudioFileId(fileId))
            }
        )
    })

    // Also check when page becomes visible again
    document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
            console.log("Page became visible, checking pending uploads...")
            debouncedProcessPendingUploads(
                (formData, success, failure) => {
                    store.dispatch(audioUpload(formData, success, failure))
                },
                fileId => {
                    // store.dispatch(setAudioFileId(fileId))
                }
            )
        }
    })
}

export const wrapRootElement = ({ element }) => {
    return (
        <Provider store={store}>
            <GlobalLayout>
                <WebSocketProvider>
                    <TwilioProvider>
                        <ThemeProvider theme={theme}>
                            <CssBaseline />
                            {element}
                        </ThemeProvider>
                    </TwilioProvider>
                </WebSocketProvider>
            </GlobalLayout>
        </Provider>
    )
}
